import {
    CloudSync,
    SettingsSuggest,
    Upload,
    FileCopy,
    DocumentErrorFilled,
    Delete,
    Merge,
} from "mosaic-react-icons";

const asideRepositoryNavigationByModule = {
    repository: [
        {
            level: 0,
            priority: 1,
            name: "label(Files)",
            to: "/:projectId/:fiscalYear/:importId/repository",
            exact: true,
            icon: Upload,
        },
    ],
    submission_saft: [
        {
            level: 0,
            priority: 5,
            name: "label(Files Submission)",
            to: "/:projectId/:fiscalYear/:importId/repository/submission_saft",
            exact: true,
            icon: CloudSync,
        },
    ],
    custom_report: [
        {
            level: 0,
            priority: 8,
            name: "label(Custom Reports)",
            to: "/:projectId/:fiscalYear/:importId/repository/custom_reports_by_project",
            exact: true,
            icon: SettingsSuggest,
        },
    ],
};

const tabsRepositoryNavigationByModules = {
    repository: [
        {
            level: 0,
            priority: 1,
            name: "Data Upload",
            to: "/:projectId/:fiscalYear/:importId/repository/activity",
            exact: true,
            icon: Upload,
        },
        {
            level: 0,
            priority: 2,
            name: "Imported Files",
            to: "/:projectId/:fiscalYear/:importId/repository/folders",
            exact: true,
            icon: FileCopy,
        },
        {
            level: 0,
            priority: 3,
            name: "Invalid Files",
            to: "/:projectId/:fiscalYear/:importId/repository/invalid_files",
            icon: DocumentErrorFilled,
            exact: true,
        },
        {
            level: 0,
            priority: 4,
            name: "Deleted Files",
            to: "/:projectId/:fiscalYear/:importId/repository/deleted_file_logs",
            icon: Delete,
            exact: true,
        },
    ],
    merge_collisions: [
        {
            level: 0,
            priority: 6,
            name: "Merge Collisions",
            to: "/:projectId/:fiscalYear/:importId/repository/merge_collisions",
            exact: true,
            icon: Merge,
        },
    ],
    merge_history: [
        {
            level: 0,
            priority: 7,
            name: "merge_history",
            to: "/:projectId/:fiscalYear/:importId/repository/merge_history",
            icon: Merge,
            exact: true,
        },
    ],
};

const filteredNavigationByModules = (modules, navigation) => {
    let resNavigation = [];
    if (modules && modules.length > 0) {
        const filteredNavigation = (modules || []).reduce((acc, elem) => {
            const menuArray = navigation[`${elem}`];
            if (menuArray) {
                acc.push(...menuArray);
            }
            return acc;
        }, []);
        const orderedNavigation = filteredNavigation.sort(function (a, b) {
            return a.priority - b.priority;
        });

        resNavigation.push(...orderedNavigation);
    }
    return resNavigation;
};

const filteredNavigationByModulesForNestedLinks = (modules, navigation) => {
    return (filteredNavigationByModules(modules, navigation) || []).map(({ name, to, icon }) => {
        return { name, to, icon };
    });
};

export {
    filteredNavigationByModulesForNestedLinks,
    asideRepositoryNavigationByModule,
    tabsRepositoryNavigationByModules,
};
